module.exports = __webpack_public_path__ + "img/public/SiteIcons/exportIcon.svg?d6139d84";